import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n-lite';
import * as _array from 'lodash/array';
import $ from 'jquery';
import routerHistory from '../../../routerHistory';
import TopBarTitle from './TopBarTitle';
import VideocallTopButton from '../../classroom/videocall/VideocallTopButton';
import UserProfileDropDown from '../dropdown/UserProfileDropDown';
import { DownloadBookManager } from '../../classroom/DownloadBookManager';
import ClassroomSettings from '../../classroom/ClassroomSettings';
import * as classroomActions from '../../../actions/classroom/classroomActions';
import * as classroomGroupActions from '../../../actions/classroom/classroomGroupActions';
import * as componentActions from '../../../actions/componentActions';
import * as sectionActions from '../../../actions/sectionActions';
import * as messageAlert from '../../../actions/messageAlertAction';
import * as contentActions from '../../../actions/contentActions';
import * as bookActions from '../../../actions/bookActions';
import { GROUPS, ROLE, ROUTES } from '../../../const';
import { getGroupName } from '../../../services/api/groupApi';
import { getParameterByName } from '../../../utils/routeUtils';
import { prettyName } from '../../../utils/stringUtils';
import { getMeetCookie } from '../../../utils/cookieUtils';
import NotConnection from '../NotConnection';
import NetexCloudMenu from '../../netexcloud-menu/NetexCloudMenu';
import axios from 'axios';
import { NETEX_CLOUD_MENU_URL } from '../../../services/api/apiConst';
import { isElectronApp, isEmbbededInTeams } from '../../../services/crossPlatform/crossPlatformService';
import Searcher from '../Searcher';
import Media from 'react-media';
import * as searchActions from '../../../actions/search/searchActions';
import MoreOptions from '../sheets/MoreOptions';
import ClassMoreSheet from './ClassMoreSheet';
import { getRoleChipLabel } from '../../../utils/classroomRoleUtils';
import { MOBILE_MEDIA_QUERY } from '../../../utils/mobileUtils';
import * as analyticsApi from '../../../services/api/analyticsApi';
import { ANALYTICS_CONTEXT, ANALYTICS_EVENT } from '../../../types/analytics';

class TopBar extends React.Component {
  state = {
    netexCloudOptionsLoaded: false,
    showMeetButton: false
  };

  constructor(props, context) {
    super(props, context);
    this.backgroundListener = null;
    this.menuListener = null;
  }

  static propTypes = {
    pathname: PropTypes.string,
    content: PropTypes.object,
    colors: PropTypes.any,
    visible: PropTypes.any,
    hasMenuLabel: PropTypes.any,
    inClassroom: PropTypes.any,
    classroom: PropTypes.any,
    layoutSettings: PropTypes.any,
    classrooms: PropTypes.any,
    messageAlert: PropTypes.any,
    componentActions: PropTypes.any,
    menuIsOpen: PropTypes.any,
    inBook: PropTypes.any,
    inBookLibrary: PropTypes.bool,
    inSearch: PropTypes.any,
    inProfile: PropTypes.any,
    sectionActions: PropTypes.any,
    group: PropTypes.any,
    classroomGroupActions: PropTypes.any,
    selectedStudent: PropTypes.any,
    classroomActions: PropTypes.any,
    location: PropTypes.any,
    enableNetexCloudMenu: PropTypes.bool,
    apiKey: PropTypes.string,
    userId: PropTypes.string,
    institutionId: PropTypes.string,
    enableContentSearcher: PropTypes.bool,
    searchMode: PropTypes.any,
    googleMeetClientId: PropTypes.string,
    jitsiDomain: PropTypes.string,
    updatedMeetConsentCookie: PropTypes.bool,
    showStatusLink: PropTypes.bool,
    jailed: PropTypes.bool,
    enableHomeView: PropTypes.bool,
    enableCreateClass: PropTypes.bool
  };

  componentDidMount() {
    const { userId, institutionId, googleMeetClientId, jitsiDomain, classroom } = this.props;
    this.retrieveNetexCloudMenu(institutionId, userId);
    const meetEnabledAndConsented =
      googleMeetClientId || jitsiDomain ? getMeetCookie({ _id: userId }) === 'true' : false;
    const showMeetButton =
      !(isElectronApp() && classroom.role === ROLE.INSTRUCTOR) && meetEnabledAndConsented && !isEmbbededInTeams();
    this.setState({ showMeetButton });
  }

  componentDidUpdate = prevProps => {
    const { classrooms, messageAlert } = this.props;

    if (prevProps.classrooms && prevProps.classrooms.length !== classrooms.length) {
      let addedClassroom = _array.xorBy(prevProps.classrooms, classrooms, 'classCode');
      if (addedClassroom && addedClassroom.length) {
        let className = addedClassroom[0].name;
        if (className) {
          className = prettyName(className, 38);
          messageAlert.success(`${I18n.t('home.successEnrollMessage')} "${className}"`);
        }
      }
    }
  };

  static getDerivedStateFromProps(nextProps) {
    if (typeof nextProps.updatedMeetConsentCookie === 'boolean') {
      const { googleMeetClientId, jitsiDomain, classroom, userId } = nextProps;
      const meetEnabledAndConsented =
        googleMeetClientId || jitsiDomain ? getMeetCookie({ _id: userId }) === 'true' : false;
      const showMeetButton =
        !(isElectronApp() && classroom.role === ROLE.INSTRUCTOR) && meetEnabledAndConsented && !isEmbbededInTeams();
      return { showMeetButton };
    }
    return {};
  }

  isDiscussionPage = () => {
    const { pathname } = this.props;
    return new RegExp(ROUTES.REGEXP.DISCUSSION_PAGE).test(pathname);
  };

  isGradebookPage = () => {
    const { pathname } = this.props;
    return new RegExp(ROUTES.REGEXP.GRADEBOOK).test(pathname);
  };

  handleLeftMenu = () => {
    const { componentActions, menuIsOpen } = this.props;

    setTimeout(function() {
      window.dispatchEvent(new CustomEvent('resize'));
    }, 500);

    if (!menuIsOpen) {
      componentActions.setMenuOpen(true);
      this.backgroundListener = $('#menu-background').click(this.closeMenuHandler);
    } else {
      componentActions.setMenuOpen(false);
    }
  };

  removeSelectedStudent = () => {
    const { classroomActions } = this.props;
    classroomActions.setSelectedStudentProfile();
  };

  closeMenuHandler = () => {
    const { componentActions } = this.props;

    if (this.menuListener) this.backgroundListener.off();
    componentActions.setMenuOpen(false);
  };

  getParameterByName(name) {
    return getParameterByName(name, this.props.location.search);
  }

  retrieveNetexCloudMenu = (institutionId, userId) => {
    if (this.props.enableNetexCloudMenu && !this.state.netexCloudOptionsLoaded && !this.netexCloudOptionsBeingLoaded) {
      this.netexCloudOptionsBeingLoaded = true;
      axios.get(`${NETEX_CLOUD_MENU_URL}?schoolId=${institutionId}&userId=${userId}`).then(response => {
        this.netexCloudOptions = response.data;
        this.setState({ netexCloudOptionsLoaded: true });
      });
    }
  };

  inGroup = () => {
    const { group } = this.props;
    return group.id !== GROUPS.EVERYONE.id;
  };

  onBackButtonClick = () => {
    const {
      inBook,
      group,
      idClassroom,
      idBook,
      inProfile,
      sectionActions,
      pathname,
      inSearch,
      classroomGroupActions,
      inBookLibrary
    } = this.props;
    const inGroup = group.id !== GROUPS.EVERYONE.id;

    if (inProfile) {
      sectionActions.setInProfile(false);
    } else if (inBookLibrary) {
      if (idBook) {
        routerHistory.push(`${ROUTES.CLASSROOM}/${idClassroom}/book/${idBook}`);
      } else {
        routerHistory.push(`${ROUTES.CLASSROOM}/${idClassroom}`);
      }
    } else if (inBook) {
      routerHistory.push(`${ROUTES.CLASSROOM}/${idClassroom}`);
    } else if (this.isDiscussionPage()) {
      const pathNameSplitted = pathname.split('/');
      routerHistory.push(pathNameSplitted.splice(0, pathNameSplitted.length - 1).join('/'));
    } else if (inGroup) {
      classroomGroupActions.setSelectedGroup(GROUPS.EVERYONE);
    } else if (inSearch) {
      routerHistory.goBack();
    } else {
      routerHistory.push(ROUTES.HOME);
    }
  };

  renderBackButton = () => {
    return (
      <button className={'hamburger hamburger--arrowturn is-active'} type="button" onClick={this.onBackButtonClick}>
        <span className="hamburger-box">
          <span className="hamburger-inner" />
        </span>
      </button>
    );
  };

  shouldRenderBackButton = () => {
    const { inClassroom, inBook, inProfile, inSearch, pathname, enableHomeView, hideImportLessonButton } = this.props;
    const inLibrary = new RegExp(ROUTES.REGEXP.CLASSROOM_BOOK_LIBRARY).test(pathname);
    if (!hideImportLessonButton && inLibrary) return true;
    const inArchive = new RegExp(ROUTES.REGEXP.ARCHIVE).test(pathname);
    const inGroup = this.inGroup();
    let shouldRender = inBook || this.isDiscussionPage() || inProfile || inArchive || inSearch || inGroup;
    if (!shouldRender) {
      return inClassroom && enableHomeView;
    }
    return !this.isJailed();
  };
  renderSettings = () => {
    const { inClassroom, classroom } = this.props;
    if (this.isJailed()) return;

    if (classroom.role === ROLE.INSTRUCTOR && inClassroom) {
      return <ClassroomSettings gearSize={18} />;
    }
  };

  renderUserOptions = (hideVideocall = false) => {
    const {
      enableNetexCloudMenu,
      institutionId,
      userId,
      googleMeetClientId,
      jitsiDomain,
      inClassroom,
      showStatusLink
    } = this.props;
    const options = this.netexCloudOptions;
    return (
      <div
        className={'flex-end'}
        onClick={() => this.retrieveNetexCloudMenu(institutionId, userId)}
        style={{ display: 'contents' }}
      >
        {this.state.showMeetButton && inClassroom && !hideVideocall && (
          <VideocallTopButton
            isElectron={isElectronApp()}
            googleMeetClientId={googleMeetClientId}
            jitsiDomain={jitsiDomain}
          />
        )}
        {!isEmbbededInTeams() && (
          <UserProfileDropDown options={options && options.contextualMenu} showStatusLink={showStatusLink} />
        )}
        {enableNetexCloudMenu && !isElectronApp() && (
          <NetexCloudMenu colored={this.shouldBeColored()} options={options && options.applicationsMenu.applications} />
        )}
      </div>
    );
  };

  shouldShowSearcher = () => {
    const { pathname } = this.props;

    const regexWhereSearcherIsNotShown = [
      ROUTES.REGEXP.TASK,
      ROUTES.REGEXP.CLASSROOM_STUDENTS,
      ROUTES.REGEXP.DISCUSSIONS,
      ROUTES.REGEXP.DISCUSSIONS_PAGE,
      ROUTES.REGEXP.DISCUSSION_PAGE,
      ROUTES.REGEXP.GRADEBOOK,
      ROUTES.REGEXP.LIBRARY
    ];

    return !regexWhereSearcherIsNotShown.some(regex => new RegExp(regex).test(pathname));
  };

  shouldBeColored = () => {
    return this.props.inClassroom;
  };

  shouldHasShadow = () => {
    const { inBook, inProfile } = this.props;
    return this.isDiscussionPage() || !this.shouldBeColored() || inBook || inProfile || this.inGroup();
  };

  getDropDownOptions = () => {
    const { group, enablePictogramConfigGroups } = this.props;
    const inGroup = group.id !== GROUPS.EVERYONE.id;
    let options = [];
    if (inGroup) {
      if (enablePictogramConfigGroups) {
        options.push({
          key: 1,
          text: I18n.t('leftMenu.pictogramView'),
          onClick: this.pictogramViewConfig,
          icon: 'custom-icons-eye-view',
          disabled: false
        });
      }
      options.push({
        key: 2,
        text: I18n.t('leftMenu.deleteGroup'),
        onClick: this.deleteGroup,
        icon: 'custom-icons-waste-can',
        danger: true,
        disabled: false
      });
      options.push({
        key: 3,
        text: I18n.t('leftMenu.editGroup'),
        onClick: this.editGroup,
        icon: 'custom-icons-edit-pencil',
        disabled: false
      });
    } else {
      options = [
        {
          key: 1,
          text: I18n.t('leftMenu.classcode'),
          onClick: this.openClassCodeReveal,
          icon: 'custom-icons-television-screen',
          disabled: false
        }
      ];
    }
    return options;
  };

  editGroup = () => {
    const { classroomGroupActions, group } = this.props;
    classroomGroupActions.setGroupToEdit(group);
    classroomGroupActions.setEditGroupIsOpen(true);
  };

  deleteGroup = () => {
    const { classroomGroupActions, group } = this.props;
    classroomGroupActions.setGroupToRemove(group);
  };

  pictogramViewConfig = () => {
    const { classroomGroupActions, group } = this.props;
    classroomGroupActions.setPictogramConfig(group);
  };

  openClassCodeReveal = () => {
    const { classroomActions } = this.props;
    classroomActions.setClassCodePopupOpen(true);
  };

  renderDropDown = () => {
    const { group } = this.props;
    if (!this.shouldShowDropDown()) return;
    return (
      <div className="margin-left-8">
        <MoreOptions
          id={'top-bar-options'}
          color="gray"
          dropdownSide="right"
          options={this.getDropDownOptions()}
          sheetTitle={getGroupName(group)}
          sheetOverline={I18n.t('rightPanel.groups.group')}
        />
      </div>
    );
  };

  // Mobile teacher header (Vista Mobile 1d): class code, searcher and videocall live in the class ⋮ sheet
  getClassSheetItems = () => {
    const { inClassroom, classroom, enableShowCodeClass, enableContentSearcher } = this.props;
    if (!inClassroom || this.inGroup() || classroom.role !== ROLE.INSTRUCTOR) {
      return null;
    }
    const items = {
      showClassCode: Boolean(enableShowCodeClass && classroom.classCode),
      showSearch: Boolean(enableContentSearcher && this.shouldShowSearcher()),
      showVideocall: Boolean(this.state.showMeetButton)
    };
    return items.showClassCode || items.showSearch || items.showVideocall ? items : null;
  };

  // The ⋮ sheet shows the class code as soon as it opens
  trackClassCodeInSheet = () => {
    const { classroom } = this.props;
    analyticsApi.trackAnalyticsEvent({
      event: ANALYTICS_EVENT.VIEW_CLASS_CODE,
      classId: classroom.id,
      context: ANALYTICS_CONTEXT.CLASS_MORE_SHEET,
      status: 'success'
    });
  };

  renderClassSheet = items => {
    const { classroom, role, googleMeetClientId, jitsiDomain, searchActions, messageAlert } = this.props;
    return (
      <div className="margin-left-8">
        <ClassMoreSheet
          {...items}
          classroomName={classroom.name}
          classCode={classroom.classCode}
          roleChipLabel={getRoleChipLabel(role, classroom.role)}
          videocallProps={{ isElectron: isElectronApp(), googleMeetClientId, jitsiDomain }}
          onSearch={() => searchActions.setSearchMode(true)}
          onCodeCopied={() => messageAlert.success(I18n.t('mobileSheets.codeCopied'))}
          onOpen={items.showClassCode ? () => this.trackClassCodeInSheet() : undefined}
        />
      </div>
    );
  };

  isTeacherInGroup = () => {
    const { classroom, group } = this.props;
    if (classroom.role != ROLE.INSTRUCTOR && group.id !== GROUPS.EVERYONE.id) {
      return false;
    }
    return true;
  };

  shouldShowDropDown = () => {
    const { inClassroom, classroom, enableShowCodeClass, group } = this.props;
    const inGroup = group.id !== GROUPS.EVERYONE.id;
    return inGroup ? true : !(!enableShowCodeClass || !inClassroom || classroom.role === ROLE.STUDENT);
  };

  isJailed = () => {
    return this.props.jailed;
  };

  render() {
    const { colors, visible, hasMenuLabel, inClassroom, group, classroom, role } = this.props;
    const inGroup = group.id !== GROUPS.EVERYONE.id;
    let topBarClass = this.shouldBeColored() ? 'top-bar classroom' : 'top-bar home-student';
    const border = this.shouldHasShadow() ? '' : 'no-border';
    if (hasMenuLabel && inClassroom) topBarClass = 'top-bar classroom with-menu';
    topBarClass += visible ? ' visible' : '';

    let style = !this.shouldBeColored()
      ? {
          backgroundColor: colors.primary
        }
      : { backgroundColor: colors.backgroundPrimary };

    return (
      <div className="header-bar" data-cy="appHeaderBar">
        <NotConnection />
        <div className={`${topBarClass} ${border}`} style={style}>
          <Media query={MOBILE_MEDIA_QUERY}>
            {matches => {
              const classSheetItems = matches ? this.getClassSheetItems() : null;
              return (
                <React.Fragment>
                  {(!matches || (matches && !this.props.searchMode)) && (
                    <div className="hamburguer-title-container">
                      {this.shouldRenderBackButton() && this.renderBackButton()}
                      <div className="title">
                        <TopBarTitle inGroup={inGroup} classroomRole={classroom.role} role={role} />
                        {inClassroom &&
                          this.isTeacherInGroup() &&
                          (classSheetItems ? this.renderClassSheet(classSheetItems) : this.renderDropDown())}
                      </div>
                    </div>
                  )}
                  {this.props.enableContentSearcher &&
                    this.shouldShowSearcher() &&
                    (!classSheetItems || this.props.searchMode) && <Searcher />}
                  {(!matches || (matches && !this.props.searchMode)) && (
                    <div className="settings-container">
                      <DownloadBookManager />
                      {this.renderSettings()}
                      {this.renderUserOptions(Boolean(classSheetItems))}
                    </div>
                  )}
                </React.Fragment>
              );
            }}
          </Media>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    classrooms: state.classrooms.classrooms,
    inProfile: state.router.inProfile,
    i18n: state.i18n,
    inClassroom: state.router.inClassroom,
    inBook: state.router.inBook,
    inSearch: state.router.location.pathname.match(ROUTES.REGEXP.SEARCH_RESULTS),
    inBookLibrary: state.router.location.pathname.match(ROUTES.REGEXP.CLASSROOM_BOOK_LIBRARY),
    menuIsOpen: state.components.menuIsOpen,
    pathname: state.router.location.pathname,
    colors: state.theme.colors,
    layoutSettings: state.theme.layoutSettings,
    classroom: state.classrooms.selectedClassroom.classroom,
    group: state.selectedGroup.group,
    selectedStudent: state.student.selectedStudent,
    location: state.router.location,
    showStatusLink: state.account.configuration.showStatusLink,
    hasMenuLabel: state.account.configuration.hasMenuLabel,
    content: state.content,
    idClassroom: state.router.params.idClassroom,
    idBook: state.router.params.idBook,
    enableNetexCloudMenu: state.account.configuration.enableNetexCloudMenu,
    apiKey: state.school.school.apiKey,
    userId: state.account.user._id,
    institutionId: state.account.user.institutionId,
    enableContentSearcher: state.account.configuration.enableContentSearcher,
    searchMode: state.search.searchMode,
    updatedMeetConsentCookie: state.cookies.updatedMeetConsentCookie,
    jailed: state.account.jailed,
    enableHomeView: state.account.configuration.enableHomeView,
    enableCreateClass: state.account.configuration.enableCreateClass,
    enableShowCodeClass: state.account.configuration.enableShowCodeClass,
    hideImportLessonButton: state.account.configuration.hideImportLessonButton,
    enablePictogramConfigGroups: state.account.configuration.enablePictogramConfigGroups
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomActions: bindActionCreators(classroomActions, dispatch),
    classroomGroupActions: bindActionCreators(classroomGroupActions, dispatch),
    componentActions: bindActionCreators(componentActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch),
    sectionActions: bindActionCreators(sectionActions, dispatch),
    contentActions: bindActionCreators(contentActions, dispatch),
    bookActions: bindActionCreators(bookActions, dispatch),
    searchActions: bindActionCreators(searchActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TopBar);
